<kendo-dialog *ngIf="confirmations && confirmations.length > 0" [width]="480" [minWidth]="360">
  <kendo-dialog-titlebar (close)="onTitlebarClose()">
    <div style="font-size: 18px; line-height: 1.3em">
      <span class="k-icon k-i-warning k-icon-md"></span> confirmation required
    </div>
  </kendo-dialog-titlebar>

  <div class="pcn-confirmation-item" *ngFor="let confirmation of confirmations">
    <p>{{ confirmation.message }}</p>

    <!-- No charges configured for this PCN's contravention/stage/action/source: there is nothing to
         pick, so say so plainly rather than showing an unusable, permanently-empty combobox with no
         explanation. This is a genuine configuration gap - resolve it in the NPS, not here. -->
    <p class="pcn-confirmation-no-options" *ngIf="!confirmation.chargeOptions?.length">
      No configured charges are available to choose from. Please resolve this PCN's charge
      configuration in the NPS, then try again.
    </p>

    <kendo-label *ngIf="confirmation.chargeOptions?.length" class="k-form" text="current charge">
      <kendo-multicolumncombobox
        [data]="confirmation.chargeOptions"
        textField="chargeAmountString"
        valueField="id"
        [valuePrimitive]="true"
        [(value)]="selectedChargeIds[confirmation.fieldName]"
        [style.width.px]="280"
      >
        <kendo-combobox-column field="totalAmount" title="Charge" [width]="75">
          <ng-template kendoMultiColumnComboBoxColumnCellTemplate let-dataItem>
            <div class="dd-template">
              {{ dataItem.totalAmount | currency: 'GBP' : 'symbol-narrow' : '1.0-0' }}
            </div>
          </ng-template>
        </kendo-combobox-column>
        <kendo-combobox-column field="chargeTypeString" title="Type" [width]="200"></kendo-combobox-column>
        <kendo-combobox-column field="feesString" title="Fees" [width]="200"></kendo-combobox-column>
      </kendo-multicolumncombobox>
    </kendo-label>
  </div>

  <!-- Feedback for the always-present kendo-dialog-titlebar close "X" (see onTitlebarClose()):
       while real options exist it's a deliberate no-op, so say why rather than leaving the user
       wondering if clicking it did nothing by accident. Clears itself once resolved. -->
  <p class="pcn-confirmation-must-select" *ngIf="showMustSelectMessage && !allResolved">
    You must select a current charge value before you can continue.
  </p>

  <kendo-dialog-actions>
    <button *ngIf="hasUnresolvableConfirmation" kendoButton (click)="onClose()">Close</button>
    <button
      kendoButton
      themeColor="primary"
      class="pcn-confirmation-confirm-button"
      [disabled]="!allResolved"
      [attr.title]="allResolved ? null : 'Select a current charge value for every field above to continue'"
      (click)="onConfirm()"
    >
      confirm
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
